// extracted by css-extract-rspack-plugin
export default {"infoSection":"_77eb336a","errorLink":"_d389b095"};